import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterRegionByNamePipe } from 'src/app/shared/pipes/filter-region-by-name/filter-region-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { RegionModalDetailComponent } from './modal/region-modal-detail/region-modal-detail.component';
import { RegionModalAjoutComponent } from './modal/region-modal-ajout/region-modal-ajout.component';
import { ListRegionComponent } from './list-region/list-region.component';

@NgModule({
	declarations: [
		ListRegionComponent,
		RegionModalDetailComponent,
		RegionModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterRegionByNamePipe]
})

export class RegionModule {}
